import { z } from "zod";

export const FormQuestionTypeValues = [
  "TextField",
  "NumberField",
  "DateField",
  "SingleChoice",
  "MultipleChoice",
  "FileField",
] as const;
export const FormQuestionTypeEnum = z.enum(FormQuestionTypeValues);
export type FormQuestionType = z.infer<typeof FormQuestionTypeEnum>;
